import DentalIndex from "../../pages/Dashboard/Dental/DentalIndex";
import DentalNav from "../../pages/Dashboard/Dental/DentalNav";
import EditPatientTreatment from "../../pages/Dashboard/Dental/PatientTreatment/EditPatientTreatment";
import PatientTreatment from "../../pages/Dashboard/Dental/PatientTreatment/PatientTreatment";
import PatientTreatmentList from "../../pages/Dashboard/Dental/PatientTreatmentList/PatientTreatmentList";
import EditPrescription from "../../pages/Dashboard/Pharmacy/prescription/EditPrescription";

import AddPrescription from "../../pages/Dashboard/Doctor/prescription/Prescription";
import PrescriptionList from "../../pages/Dashboard/Dental/prescription/PrescriptionList";
import ListProcedures from "../../pages/Dashboard/Dental/Procedures/ListProcedures";
import Procedures from "../../pages/Dashboard/Dental/Procedures/Procedures";
import NewPatient from "../../pages/Dashboard/Reception/NewPatient/NewPatient";
import PatientList from "../../pages/Dashboard/Reception/PatientList/PatientList";

const dentalRoutes = {
  path: "/dental",
  element: <DentalNav />,
  children: [
    { path: "/dental", element: <DentalIndex /> },
    { path: "/dental/new-patient", element: <NewPatient /> },
    { path: "/dental/patient-list", element: <PatientList /> },
    { path: "/dental/procedures", element: <ListProcedures /> },
    { path: "/dental/procedures/add", element: <Procedures /> },
    { path: "/dental/patient-treatments", element: <PatientTreatment /> },
    {
      path: "/dental/patient-treatments/:id",
      element: <EditPatientTreatment />,
    },
    {
      path: "/dental/patient-treatments-list",
      element: <PatientTreatmentList />,
    },
    { path: "/dental/prescription", element: <PrescriptionList /> },
    { path: "/dental/prescription/:id", element: <EditPrescription /> },
    { path: "/dental/prescription/add", element: <AddPrescription /> },
  ],
};

export default dentalRoutes;
